import React from 'react';

import PropTypes from 'prop-types';
import { Map } from 'immutable';

import { Col } from 'react-bootstrap';
import cn from 'classnames';
import CheckoutController from '../../../event_components/Checkout';
import Title from '../../../event_components/title';
import Details from '../../../event_components/details';
import styles from './checkout-only.scss';
import EventStatus from '../../../event_components/event_status';
import TicketPurchasing from '../../../event_components/ticket-purchasing';
import AddEventToCalendar from '../../../event_components/add_to_calendar';
import { LocaleWrapper } from '../../../../locale-wrapper';
import Host from '../../../event_components/host';
import TwitchPreviousVideo from '../../../event_components/twitch-video';
import PaginationContainer from '../../shared/pagination_container';
import { EventTime } from '../../../event_components/event-time';
import { EventDate } from '../../../event_components/event-date';
import Logo from '../../../event_components/logo';
import { mobileLayoutComponent } from '../../shared/mobileLayoutComponent';
import { LocationItem } from '../../shared/location-item/location-item';
import DateRangeIcon from '@mui/icons-material/DateRange';
import WatchLaterSharpIcon from '@mui/icons-material/WatchLaterSharp';
import { EventOccurrences } from '../../../event_components/event-occurrences';

const propTypes = {
  event: PropTypes.instanceOf(Map).isRequired,
  settings: PropTypes.instanceOf(Map).isRequired,
};

export class ListEvent extends React.Component {
  constructor() {
    super();
    this.state = {
      openTicketing: false,
    };
  }

  toggleAttendButton = () => {
    const { event, onEventRegister } = this.props;

    if (event.get('type') === 'google') {
      return;
    }
    this.props.onResizeComponent();
    this.setState(
      {
        openTicketing: onEventRegister ? false : !this.state.openTicketing,
      },
      () => this.props.onResizeComponent()
    );
    onEventRegister && onEventRegister(event);
  };

  render() {
    const { event, settings, onResizeComponent } = this.props;
    const logo = event.getIn(['logo', 'url']);

    const hasLogo = settings.get('showEventLogo');
    if (event.get('initial_embed') || event.get('is_offline')) {
      return event.get('is_offline') ? (
        <TwitchPreviousVideo settings={settings} event={event} />
      ) : (
        <TicketPurchasing event={event} settings={settings} open onResizeComponent={onResizeComponent} />
      );
    }

    const xsLogoVisible = logo && hasLogo && event.get('type') !== 'google' && event.get('type') !== 'zoom';

    return (
      <div className={styles.container}>
        <div className={cn(styles.list, 'event')}>
          {xsLogoVisible && <Logo event={event} settings={settings} className={styles.listPhoto} />}
          {event.get('type') === 'zoom' && (
            <Col xs={6} md={4} className={styles.zoomColumn}>
              <Host event={event} settings={settings} />
            </Col>
          )}

          <Col className={styles.details}>
            <Title event={event} settings={settings} />
            <div className={styles.eventFactsList}>
              <LocationItem event={event} settings={settings} className={styles.locationItem} />
              {event.get('upcoming_events') ? (
                <div className={styles.factItem}>
                  <DateRangeIcon alt="date" width="20px" className="date" />
                  <EventOccurrences event={event} settings={settings} />
                </div>
              ) : (
                <div className={styles.factItem}>
                  <DateRangeIcon alt="date" width="20px" className="date" />
                  <EventDate event={event} settings={settings} />
                </div>
              )}
              <div className={styles.factItem}>
                <WatchLaterSharpIcon alt="time" width="20px" className="date" />
                <EventTime event={event} settings={settings} />
              </div>
            </div>

            {settings.get('showEventStatus') && <EventStatus event={event} settings={settings} />}
            {settings.get('enableAddToCalendar') && <AddEventToCalendar event={event} settings={settings} className={styles.addToCalendar} />}
            <Details event={event} settings={settings} className={styles.description} onResizeComponent={onResizeComponent} />
          </Col>
        </div>
        <div className={styles.checkoutWrapper}>
          <CheckoutController
            variant={this.props.variant}
            event={event}
            settings={settings}
            inClassName={cn('checkout-fade')}
            openTicketing
            onResizeComponent={onResizeComponent}
          />
        </div>
      </div>
    );
  }
}

ListEvent.propTypes = propTypes;

export default function CheckoutOnly({ events, settings, isMobile, onResizeComponent, onEventRegister, forceButtonNewRow, variant }) {
  const Component = isMobile ? mobileLayoutComponent(settings) : ListEvent;

  const renderEvent = (event) => (
    <LocaleWrapper event={event}>
      <Component
        key={event.get('id')}
        event={event}
        settings={settings}
        onResizeComponent={onResizeComponent}
        onEventRegister={onEventRegister}
        forceButtonNewRow={forceButtonNewRow}
        variant={variant}
      />
    </LocaleWrapper>
  );

  return <PaginationContainer events={events} settings={settings} onResizeComponent={onResizeComponent} renderEvent={renderEvent} />;
}

CheckoutOnly.propTypes = {
  events: PropTypes.instanceOf(Map).isRequired,
  settings: PropTypes.instanceOf(Map).isRequired,
  isMobile: PropTypes.bool,
};
